<!-- <h2 mat-dialog-title>Add Remarks</h2>
<mat-dialog-content>
  <mat-form-field>
    <mat-label>Remarks</mat-label>
    <textarea matInput [(ngModel)]="remarks" maxlength="500"></textarea>
    <mat-hint align="end">{{remarks.length}}/500</mat-hint>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button (click)="onSave()">Save</button>
</mat-dialog-actions> -->


<div>
	<div class="row">
	  <h6 class="text-dark float-right">Add Remarks</h6>
	</div>
	<div mat-dialog-content>
	  <div class="row justify-content-center mb-4 mt-3 mb-3">
		<mat-form-field class="full-width">
		  <mat-label>Remarks</mat-label>
		  <textarea matInput [(ngModel)]="remarks" maxlength="500"></textarea>
		  <mat-hint align="end">{{remarks.length}}/500</mat-hint>
		</mat-form-field>
	  </div>
	</div>
	<div mat-dialog-actions class="justify-content-end mt-5">
	  <button class="mr-3" type="button" mat-raised-button color="warn" (click)="onCancel()">Close</button>
	  <button class="mr-3" type="button" mat-raised-button color="primary" (click)="onSave()">Save</button>
	</div>
  </div>

